/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type PdpSharedAuctionActionBid_item = {
    readonly " $fragmentRefs": FragmentRefs<"PriceDisplay_item" | "useAuctionBids_item" | "PdpSharedAuctionBidsDetails_item" | "PdpSharedAuctionCountdownLazy_item" | "PdpSharedAuctionActionBidLabel_item">;
    readonly " $refType": "PdpSharedAuctionActionBid_item";
};
export type PdpSharedAuctionActionBid_item$data = PdpSharedAuctionActionBid_item;
export type PdpSharedAuctionActionBid_item$key = {
    readonly " $data"?: PdpSharedAuctionActionBid_item$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedAuctionActionBid_item">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "fetchUser"
    },
    {
      "kind": "RootArgument",
      "name": "isTrade"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedAuctionActionBid_item",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "isTrade",
          "variableName": "isTrade"
        },
        {
          "kind": "Variable",
          "name": "userId",
          "variableName": "userId"
        }
      ],
      "kind": "FragmentSpread",
      "name": "PriceDisplay_item"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "fetchUser",
          "variableName": "fetchUser"
        }
      ],
      "kind": "FragmentSpread",
      "name": "useAuctionBids_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedAuctionBidsDetails_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedAuctionCountdownLazy_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedAuctionActionBidLabel_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};
(node as any).hash = '340cf7da460b253c99fc7205f94a78b2';
export default node;
